import React from 'react'
import { Tooltip } from 'react-tooltip'
import Icons from '../../Icons'
export default class CheckBox extends React.Component {
    constructor(props) {
        super(props)
        this.ref = React.createRef()
    }

    onClick() {
        if (this.props.disabled) return
        this.ref.current.click()
    }

    render() {
        let outerClassName = 'checkboxWrapper '
        if (this.props.outerClassName) outerClassName += this.props.outerClassName

        var isChecked = false
        if (this.props.checked && this.props.checked != '0' && this.props.checked != 0) {
            isChecked = true
            outerClassName += ' checked'
        }

        if (this.props.disabled) {
            outerClassName += ' disabled'
        }

        let label = ''
        if ((this.props.label && this.props.labelOptions) || this.props.labelOptions) {
            label = (
                <div className='txtInput_label_flex'>
                    <div className='txtInput_label'>{this.props.label}</div>
                    <div className='txtInput_labelOptions'>{this.props.labelOptions}</div>
                </div>
            )
        } else if (this.props.label && this.props.labelSub) {
            label = (
                <div className='txtInput_label_sub'>
                    <div className='txtInput_label'>{this.props.label}</div>
                    <div className='txtInput_labelSub'>{this.props.labelSub}</div>
                </div>
            )
        } else if (this.props.label) {
            label = <div className='txtInput_label'>{this.props.label}</div>
        }

        return (
            <div className={outerClassName} style={this.props.outerStyle} onClick={this.onClick.bind(this)}>
                {label}
                <input
                    type='checkbox'
                    name={this.props.name}
                    className={'checkbox ' + this.props.className}
                    onClick={this.props.onClick}
                    onChange={this.props.onChange || function () {}}
                    checked={isChecked}
                    disabled={this.props.disabled}
                    style={this.props.style}
                    ref={this.ref}
                    data-tooltip-content={this.props['data-tooltip-content']}
                    data-tooltip-id={this.props['data-tooltip-id']}
                />
                {this.props['data-tooltip-content'] && this.props['data-tooltip-id'] && (
                    <Tooltip id={this.props['data-tooltip-id']} />
                )}
                <div className='icon'>
                    <Icons icon='tick' color='white' style={{ height: 18, width: 18 }} />
                </div>
                {this.props.children}
            </div>
        )
    }
}
